import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { Howl } from 'howler'
import { pxToRem } from './utilities'

gsap.registerPlugin(ScrollToPlugin)

const pricing = (el) => {

	const input = el.querySelector('#pricing')

	if (!input) return

	const sfx = new Howl({
    src: ['dist/audio/bloop.mp3'],
    loop: false,
    autoplay: false,
    volume: 0.1
  })

	const slider = el.querySelector('.pricing__slider')
	const track = el.querySelector('.pricing__track-scroller')
	const indicators = el.querySelectorAll('.pricing__indicator')
	const label = el.querySelector('.pricing__label')
	const grabber = el.querySelector('.pricing__grabber')
	const inner = el.querySelector('.pricing__inner')
	const amount = el.querySelector('.pricing__label #amount')
	const price = el.querySelector('.pricing__slider-price #price')
	const prev = el.querySelector('.pricing__prev')
	const next = el.querySelector('.pricing__next')

	input.addEventListener('input', (e) => {
		const i = Number(e.target.value) - 1
		sfx.play()
		updatePrice(i)
		animateIndicators(i)
		toggleMostPopular(i)
		scrollToIndictator(indicators[i], track)
	})

	next.addEventListener('click', () => {
		const i = Number(input.value) + 1
		input.value = i
		updatePrice(i)
		animateIndicators(i)
		toggleMostPopular(i)
		scrollToIndictator(indicators[i], track)
	})
	
	prev.addEventListener('click', () => {
		console.log(input.value)
		const i = Number(input.value) - 1
		input.value = i
		updatePrice(i)
		animateIndicators(i)
		toggleMostPopular(i)
		scrollToIndictator(indicators[i], track)
	})

	const updatePrice = (i) => {
		price.innerHTML = formatNumber(indicators[i].dataset.cost)
		amount.innerHTML = formatNumber(indicators[i].dataset.emails)

		setTimeout(() => {
			if (label.getBoundingClientRect().right > (inner.getBoundingClientRect().right - 100)) {
				label.classList.add('flipped')
			}
			if (label.getBoundingClientRect().left < (inner.getBoundingClientRect().left + 100)) {
				label.classList.remove('flipped')
			}
		}, 75)
	}

	const animateIndicators = (i) => {
		gsap.to(label, {
			duration: 0.2,
			x: `${pxToRem(calcLeftDistance(indicators[i], slider))}rem`
		})

		gsap.to(grabber, {
			duration: 0.2,
			x: `${pxToRem(calcLeftDistance(indicators[i], slider))}rem`
		})

		gsap.to(indicators, {
			duration: 0.2,
			opacity: 0.4,
			height: window.innerWidth > 650 ? `${pxToRem(24)}rem` : `${pxToRem(36)}rem`
		})

		if (indicators[i - 2]) {
			gsap.to(indicators[i - 2], {
				duration: 0.2,
				opacity: 0.75,
				height: window.innerWidth > 650 ? `${pxToRem(48)}rem` : `${pxToRem(36)}rem`
			})
		}

		if (indicators[i + 2]) {
			gsap.to(indicators[i + 2], {
				duration: 0.2,
				opacity: 0.75,
				height: window.innerWidth > 650 ? `${pxToRem(48)}rem` : `${pxToRem(36)}rem`
			})
		}

		if (indicators[i - 1]) {
			gsap.to(indicators[i - 1], {
				duration: 0.2,
				opacity: 0.75,
				height: window.innerWidth > 650 ? `${pxToRem(72)}rem` : `${pxToRem(48)}rem`
			})
		}

		if (indicators[i + 1]) {
			gsap.to(indicators[i + 1], {
				duration: 0.2,
				opacity: 0.75,
				height: window.innerWidth > 650 ? `${pxToRem(72)}rem` : `${pxToRem(48)}rem`
			})
		}

		gsap.to(indicators[i], {
			duration: 0.2,
			opacity: 1,
			height: '100%'
		})

		const pulsePrice = gsap.timeline()
		const sliderPrice = el.querySelector('.pricing__slider-price')
		pulsePrice.to(sliderPrice, { duration: 0.1, scale: 1.05 })
		pulsePrice.to(sliderPrice, { duration: 0.1, scale: 1 })
	}

	const toggleMostPopular = (i) => {
		if (indicators[i].dataset.type == 'mostPopular') {
			label.classList.add('most-popular')
		} else {
			label.classList.remove('most-popular')
		}
	}

	const cursorEvents = () => {
		const cursor = document.querySelector('.pricing__grabber')
		const slider = document.querySelector('.pricing__slider input')
	
		slider.addEventListener('mousedown', (e) => cursor.classList.add('shrink'))
		slider.addEventListener('mouseup', (e) => cursor.classList.remove('shrink'))
	}
	
	const formatNumber = (number) => {
		if (number >= 1000000) {
			return (number / 1000000).toFixed(1).replace(/\.0$/, '') + 'm'
		} else if (number >= 1000) {
			return (number / 1000).toFixed(1).replace(/\.0$/, '') + 'k'
		} else {
			return number
		}
	}

	const calcLeftDistance = (child, parent) => {
		let leftDistance = 0
		let currentElement = child

		while (currentElement && currentElement !== parent) {
			leftDistance += currentElement.offsetLeft
			currentElement = currentElement.offsetParent
		}

		if (currentElement !== parent) {
			throw new Error('The specified parent is not an ancestor of the child element.')
		}

		return leftDistance
	}

	const scrollToIndictator = (child, parent) => {
    const childLeft = child.offsetLeft
    const childCenter = childLeft + (child.offsetWidth / 2)

    const parentCenter = parent.clientWidth / 2
    const scrollPosition = childCenter - parentCenter

		gsap.to(parent, {
			duration: 1,
			scrollTo: {
				y: 0,
				x: scrollPosition
			}
		})
	} 

	cursorEvents()
	updatePrice(Number(slider.dataset.default))
	animateIndicators(Number(slider.dataset.default))
	toggleMostPopular(Number(slider.dataset.default))
	scrollToIndictator(indicators[Number(slider.dataset.default)], track)
}

export const initPricing = () => {
	document.querySelectorAll('.pricing').forEach(el => {
		pricing(el)
	})
}

export default () => {}